import _slicedToArray from "@babel/runtime-corejs3/helpers/slicedToArray";import _Object$keys from "@babel/runtime-corejs3/core-js-stable/object/keys";import _mapInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/map";import _findInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/find";import _concatInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/concat";import _sortInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/sort";import React, { useState } from 'react';
import clsx from 'clsx';
import Button from "../../Button";


import Spinner from "../../Spinner";
import { employerRights } from "../../../utils/accessRights";
import useWindowDimensions from "../../../hooks/useWindowDimensions";
import { createStyles } from "./styles";
import ProductRates from "../common/ProductRates";
import { filterByPlAndAttrField } from "../common/utils";
import CardHeader from "../common/CardHeader";
import ProductTiles from "../common/ProductTiles";
import SponsorHeader from "../common/SponsorHeader";
import BrowsingSelect from "../BrowsingSelect";



var ProposalCard = function ProposalCard(props) {var _context3;
  var
    productLineAttributes =












    props.productLineAttributes,_props$isPlanConfigur = props.isPlanConfigurable,isPlanConfigurable = _props$isPlanConfigur === void 0 ? true : _props$isPlanConfigur,isProposalConfirmed = props.isProposalConfirmed,_props$userRoles = props.userRoles,userRoles = _props$userRoles === void 0 ? [] : _props$userRoles,marketingTags = props.marketingTags,_props$portfolio = props.portfolio,portfolioId = _props$portfolio.id,portfolioName = _props$portfolio.name,products = _props$portfolio.products,marketingTagIds = _props$portfolio.marketingTagIds,productLineId = _props$portfolio.productLineId,onViewPlanDetails = props.onViewPlanDetails,onConfigurePortfolio = props.onConfigurePortfolio,onBrowsingChange = props.onBrowsingChange,_props$cartItem = props.cartItem,isCartItemSelected = _props$cartItem.confirmed,selectedIndex = _props$cartItem.selectedIndex,browsingCriteria = _props$cartItem.browsingCriteria,loading = props.loading,_props$breakpoint = props.breakpoint,breakpoint = _props$breakpoint === void 0 ? 0 : _props$breakpoint,additionalSection = props.additionalSection;

  var _useState = useState(
    selectedIndex || Number(_Object$keys(browsingCriteria)[0])),_useState2 = _slicedToArray(_useState, 2),browsingValue = _useState2[0],setBrowsingValue = _useState2[1];


  var isMultiProductPortfolio = products.length > 1;
  var isPortfolioWithSeveralBc = _Object$keys(browsingCriteria).length > 1;
  var showMobileLayoutVersion = useWindowDimensions().width <= breakpoint;
  var classes = createStyles({
    isMultiProductPortfolio: isMultiProductPortfolio,
    isPortfolioWithSeveralBc: isPortfolioWithSeveralBc,
    showMobileLayoutVersion: showMobileLayoutVersion
  });

  var changeBrowsingValue = function changeBrowsingValue(e) {
    setBrowsingValue(Number(e.target.value));
    onBrowsingChange(portfolioId, Number(e.target.value));
  };

  // Dynamic links in attributes info
  var ProductDynamicLinks = function ProductDynamicLinks(productAttrs, productLine) {var _context;
    return _mapInstanceProperty(_context = filterByPlAndAttrField(productLineAttributes, 'link', productLine)).call(_context,
    function (_ref) {var _productAttrs$find, _context2;var displayName = _ref.displayName,id = _ref.id;
      // get attribute value from the list of all product attributes
      var currentAttrLink =
      ((_productAttrs$find = _findInstanceProperty(productAttrs).call(productAttrs, function (_ref2) {var attributeId = _ref2.attributeId;return attributeId === id;})) === null || _productAttrs$find === void 0 ? void 0 : _productAttrs$find.attributeValue) || '';

      return /*#__PURE__*/(
        React.createElement(Button, {
          id: _concatInstanceProperty(_context2 = "".concat(portfolioId, "-attr")).call(_context2, id),
          key: id,
          type: "text",
          color: "primary",
          className: classes.actionButton,
          onClick: function onClick() {
            window.open(currentAttrLink, '_blank');
          } },

        displayName));


    });

  };

  // Wrapper for header component as only 2 props are unique in different views
  var ProductCardHeader = function ProductCardHeader(name, view) {return /*#__PURE__*/(
      React.createElement(CardHeader, {
        name: name,
        view: view,
        isConfigurable: isPlanConfigurable && !employerRights(userRoles) && !isProposalConfirmed,
        isCartItemSelected: isCartItemSelected,
        portfolioId: portfolioId,
        onViewPlanDetails: onViewPlanDetails,
        onConfigurePortfolio: onConfigurePortfolio,
        className:
        showMobileLayoutVersion ? classes.mobileProductNameWrapper : classes.productNameWrapper }));};




  var CommonBrowsingSelect = function CommonBrowsingSelect(id) {
    return /*#__PURE__*/(
      React.createElement(BrowsingSelect, {
        id: id,
        isPortfolioWithSeveralBc: isPortfolioWithSeveralBc,
        isMultiProductPortfolio: isMultiProductPortfolio,
        browsingValue: browsingValue.toString(),
        browsingCriteria: browsingCriteria,
        productLineId: productLineId,
        changeBrowsingValue: changeBrowsingValue }));


  };

  return /*#__PURE__*/(
    React.createElement("div", {
      className: clsx(
      classes.cartItemContentWrapper,
      isCartItemSelected && classes.cartItemContentWrapperChecked),

      key: "planCard_".concat(portfolioId) }, /*#__PURE__*/


    React.createElement(SponsorHeader, {
      carrier: products[0].carrier,
      marketingTagIds: marketingTagIds,
      portfolioId: portfolioId,
      marketingTags: marketingTags,
      styles: showMobileLayoutVersion ? classes.mobileCardHeader : classes.cardHeader }),


    isMultiProductPortfolio && /*#__PURE__*/
    React.createElement(React.Fragment, null,
    ProductCardHeader(portfolioName, 'PORTFOLIO'),
    CommonBrowsingSelect(portfolioId)), /*#__PURE__*/



    React.createElement("div", { className: classes.productList },
    _mapInstanceProperty(_context3 = _sortInstanceProperty(products).call(products,
    function (a, b) {return a.imProductId > b.imProductId ? 1 : -1;})).call(_context3,
    function (_ref3) {var imProductId = _ref3.imProductId,productDisplayName = _ref3.productDisplayName,bcDependentData = _ref3.bcDependentData,productLine = _ref3.productLine,disabled = _ref3.disabled;
      var currentBcInfo = bcDependentData[browsingValue];
      var productAttributes = currentBcInfo.productAttributes,rates = currentBcInfo.rates;

      return /*#__PURE__*/(
        React.createElement("div", {
          key: "productCard_".concat(imProductId),
          className: clsx(classes.innerProduct, disabled && classes.disabledProduct) },

        ProductCardHeader(
        productDisplayName,
        products.length === 1 ? 'PORTFOLIO' : 'PRODUCT'),

        !isMultiProductPortfolio && CommonBrowsingSelect(portfolioId), /*#__PURE__*/


        React.createElement("div", { key: imProductId, className: classes.productContentWrapper }, /*#__PURE__*/
        React.createElement("div", { className: classes.portfolioMainData }, /*#__PURE__*/
        React.createElement(ProductRates, {
          id: imProductId,
          rates: rates,
          styles: clsx(
          classes.ratesList,
          // hide border if there are no dynamic links
          ProductDynamicLinks(productAttributes, productLine).length === 0 &&
          classes.ratesAdditionalStyle) }),


        additionalSection && additionalSection(productLineId, rates),
        ProductDynamicLinks(productAttributes, productLine)), /*#__PURE__*/


        React.createElement(ProductTiles, {
          productLineAttrs: productLineAttributes,
          productAttrs: productAttributes,
          productLine: productLine,
          styles:
          showMobileLayoutVersion ? classes.mobileProductTiles : classes.productTiles }))));





    })),

    loading && /*#__PURE__*/
    React.createElement("div", { className: classes.spinnerWrapper }, /*#__PURE__*/
    React.createElement(Spinner, { size: "5rem" }))));




};

export default ProposalCard;
//# sourceMappingURL=index.js.map